import { createFileRoute } from "@tanstack/react-router";

import { VerificationAuditLogsPage } from "@/pages/Admin";

export const Route = createFileRoute("/app/admin/verification/audit-logs")({
  component: VerificationAuditLogsPage,
});
